<app-loader *ngIf="loaderIcon | async"></app-loader>
<div class="border p-3 rounded shadow-sm mb-2">
  <div class="row g-2 align-items-center">
    <div class="col-lg-5">
      <div class="row">
        <div class="col-6">
          <p class="mb-1"><strong>{{'Vendor ID : ' | wordReplace}}</strong>{{vendorInfo?.MarketVendorId}}</p>
          <p class="mb-1"><strong>Name :</strong> {{vendorInfo?.VendorName}}</p>
        </div>
        <div class="col-6">
          <p class="mb-1"><strong>Phone :</strong> {{vendorInfo?.Telephone | phoneFormat}}</p>
          <p class="mb-1"><strong>Email :</strong> {{vendorInfo?.Email}}</p>
        </div>
      </div>
    </div>
    <div class="col-lg-7 d-flex align-items-center gap-2"></div>
  </div>
  <div class="row mt-2">
    <div class="col-12 d-flex align-items-center mb-2">
      <label class="form-label mb-0 me-2 fw-bold text-nowrap" style="width: 140px;">Rental Notes :</label>
      <div class="input-group">
        <input type="text" class="form-control" [(ngModel)]="finalRentalNotes">
        <button class="btn btn-dark ms-2" style="padding-bottom: 12px; border-radius: 6px;" type="button"
          data-bs-toggle="modal" data-bs-target="#modalPayRentalNotes" (click)="bindRentalNotes()">...</button>
      </div>
    </div>
    <div class="col-12 d-flex align-items-center">
      <label class="form-label mb-0 me-2 fw-bold text-nowrap" style="width: 140px;">Vendor Comments :</label>
      <div class="input-group">
        <input type="text" class="form-control" [(ngModel)]="finalVendorComment">
        <button class="btn btn-dark ms-2" style="padding-bottom: 12px; border-radius: 6px;" type="button"
          data-bs-toggle="modal" data-bs-target="#modalPayVendorComments" (click)="bindVendorComments()">...</button>
      </div>
    </div>
  </div>
</div>
<form [formGroup]="paymentForm">
  <div class="row" *ngIf="!processPayment && !voidPayment">
    <div class="col-sm-12 col-md-12 col-lg-8 col-xl-8 text-start mt-2">
      <div class="row">
        <div class="col-sm-12 col-md-12 col-lg-9 col-xl-9 text-start mt-2">
          <div class="row mb-2">
            <div class="col-12 text-start">
              <label class="heading">{{'Booth Rentals' | wordReplace}}</label>
            </div>
          </div>
          <ejs-grid [allowSorting]="true" [dataSource]="rentalDues" class="e-grid-custom" [height]="350">
            <e-columns>
              <e-column field="BoothNum" [headerText]="'Booth #' | wordReplace" width="150" textAlign="left"></e-column>
              <e-column field="TrxDate" headerText="Trx Date" width="150" textAlign="left"></e-column>
              <e-column field="RentalPeriodToDisp" headerText="Rental Period" textAlign="left" width="150"></e-column>
              <e-column field="Rent" headerText="Rent" textAlign="right" width="150"></e-column>
              <e-column field="Tax1" headerText="Sales Tax" textAlign="right" width="150"></e-column>
              <e-column field="Tax2" headerText="Second Tax" textAlign="right" width="150"></e-column>
              <e-column field="Paid" headerText="Paid" textAlign="right" width="150"></e-column>
              <!-- <e-column field="BalFwd" headerText="Bal-Fwd" textAlign="right" width="250"></e-column> -->
              <e-column field="Due" headerText="Due" textAlign="right" width="150"></e-column>
              <e-column field="Payment" headerText="Payment" textAlign="right" width="150"></e-column>
              <e-column field="CrAmt" headerText="Cr Amt" textAlign="right" width="150"></e-column>
            </e-columns>
          </ejs-grid>
          <div class="row my-2">
            <div class="col-12 text-start">
              <label class="heading">Other Rentals</label>
            </div>
          </div>
          <ejs-grid [allowSorting]="true" [dataSource]="otherRentalDues" class="e-grid-custom" [height]="350">
            <e-columns>
              <e-column field="OtherItem" headerText="Item" width="150" textAlign="left"></e-column>
              <e-column field="TrxDate" headerText="Trx Date" width="150" textAlign="left"></e-column>
              <e-column field="RentalPeriodToDisp" headerText="Rental Period" textAlign="left" width="150"></e-column>
              <e-column field="Rent" headerText="Charge" textAlign="right" width="150"></e-column>
              <e-column field="Tax1" headerText="Sales Tax" textAlign="right" width="150"></e-column>
              <e-column field="Tax2" headerText="Second Tax" textAlign="right" width="150"></e-column>
              <e-column field="Paid" headerText="Paid" textAlign="right" width="150"></e-column>
              <!-- <e-column field="BalFwd" headerText="Bal-Fwd" textAlign="right" width="250"></e-column> -->
              <e-column field="Due" headerText="Due" textAlign="right" width="150"></e-column>
              <e-column field="Payment" headerText="Payment" textAlign="right" width="150"></e-column>
              <e-column field="CrAmt" headerText="Cr Amt" textAlign="right" width="150"></e-column>
            </e-columns>
          </ejs-grid>
        </div>
        <div class="col-sm-12 col-md-12 col-lg-3 col-xl-3 text-start mt-2">
          <div class="border rounded p-3" style="width: 140px;">
            <h6 class="fw-bold mb-3">Receipt ID</h6>

            <div class="form-check mb-2" *ngFor="let id of accountReceiptIds; let i = index">
              <input class="form-check-input" type="checkbox" [id]="'receipt' + i" [(ngModel)]="selectedReceiptIds[i]"
                [ngModelOptions]="{ standalone: true }" (change)="onReceiptToggle(id, $event.target.checked)">
              <label class="form-check-label" [for]="'receipt' + i">
                {{ id }}
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-sm-12 col-md-12 col-lg-4 col-xl-4 text-start mt-2">
      <div class="border rounded p-3 mb-3">
        <div class="row g-2">
          <div class="col-6">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="displayPayReceipt" formControlName="displayReceipt">
              <label class="form-check-label" for="displayPayReceipt">Display Receipt</label>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="printPayReceipt" formControlName="printReceipt">
              <label class="form-check-label" for="printPayReceipt">Print Receipt</label>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="emailPayReceipt" formControlName="emailReceipt">
              <label class="form-check-label" for="emailPayReceipt">Email Receipt</label>
            </div>
          </div>
          <!-- <div class="col-6">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="displayPayContract">
              <label class="form-check-label" for="displayPayContract">Display Contract</label>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="printPayContract">
              <label class="form-check-label" for="printPayContract">Print Contract</label>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="emailPayContract">
              <label class="form-check-label" for="emailPayContract">Email Contract</label>
            </div>
          </div> -->
        </div>
      </div>
      <!-- Payments Section -->
      <div class="mt-3 border rounded p-3" formGroupName="paymentDetails">
        <div class="d-flex justify-content-between align-items-center mb-2">
          <label class="heading mb-0">Payments</label>
          <label class="fw-bold text-danger mb-0">CC charge: {{ ccChargeDisplay }}</label>
        </div>
        <div class="row g-2 mb-2">
          <div class="col-6">
            <label class="text-danger text-red">Total Due</label>
            <input type="text" class="form-control text-end" readonly formControlName="totalDue">
          </div>
          <div class="col-6">
            <label class="text-danger text-red">Prior AR Balance</label>
            <input type="text" class="form-control text-end" readonly formControlName="priorARBalance">
          </div>
        </div>
        <div class="row g-2 mb-2">
          <div class="col-6">
            <label>Cash</label>
            <input type="text" class="form-control text-end" formControlName="cashAmount" (click)="handleClick($event)"
              (dblclick)="handledblClick($event)" (keypress)="numberOnlyForCash($event)" (blur)="onCashBlur()">
          </div>
          <div class="col-6">
            <label>Change Amount</label>
            <input *ngIf="calculateChangeAmount; else changeAmountNotApplicable" type="text"
              class="form-control text-end" formControlName="changeAmount" (keypress)="numberOnly($event)"
              (click)="handleClick($event)" (dblclick)="handledblClick($event)" readonly>
            <ng-template #changeAmountNotApplicable>
              <input type="text" class="form-control fw-bold" value="Not Applicable" readonly>
            </ng-template>
          </div>
        </div>

        <div class="row g-2 mb-2">
          <div class="col-6">
            <label>Check</label>
            <input type="text" class="form-control text-end" formControlName="checkAmount"
              (keypress)="numberOnly($event)" (click)="handleClick($event)" (dblclick)="handledblClick($event)"
              (change)="calculatePaymentDistribution()">
          </div>
          <div class=" col-6">
            <label>Check#</label>
            <input type="text" class="form-control" #checkNo (keydown)="onCheckNumKeyPress($event)"
              formControlName="checkNo" MaxLength="20">
          </div>
        </div>

        <div class="row g-2 mb-2">
          <div class="col-6">
            <label>Credit/Debit Card</label>
            <input type="text" class="form-control text-end" formControlName="creditCardAmount"
              (keypress)="numberOnly($event)" (click)="handleClick($event)" (dblclick)="handledblClick($event)"
              (change)="calculateConvenienceFee()">
          </div>
          <div class="col-6">
            <label>Direct Debit Payment</label>
            <input type="text" class="form-control text-end" formControlName="directDebitAmount"
              (keypress)="numberOnly($event)" (click)="handleClick($event)" (dblclick)="handledblClick($event)"
              (change)="calculatePaymentDistribution()">
          </div>
        </div>

        <div class="row g-2 mb-2">
          <div class="col-6">
            <label>Card Type</label>
            <select class="form-select" formControlName="creditCards" (change)="checkPaymentType()">
              <option *ngFor="let item of creditCardList" [value]="item.CreditCardTypeId">
                {{item.CreditCardTypeDesc}}
              </option>
            </select>
          </div>
          <div class="col-6">
            <label>CC Fee</label>
            <input type="text" class="form-control text-end fw-bold" formControlName="convenienceFee" readonly>
          </div>
        </div>

        <div class="row g-2 mb-2" *ngIf="displayApplyCredit">
          <div class="col-6">
            <label>Existing Credit</label>
            <input type="text" class="form-control text-end" formControlName="ExistingCredit">
          </div>
          <div class="col-6">
            <div class="form-check mt-3">
              <input class="form-check-input" type="checkbox" id="applyCredit" formControlName="applyCredit"
                (change)="calculatePaymentDistribution()">
              <label class="form-check-label" for="applyCredit">Apply Credit</label>
            </div>
          </div>
        </div>

        <div class="row g-2 mb-2" *ngIf="isRentalCashRoundingEnabled">
          <div class="col-6">
            <label>Rounding Off Amount</label>
            <input type="text" class="form-control text-end" formControlName="roundingAmount">
          </div>
        </div>

        <div class="mt-3">
          <div class="col-12">
            <label class="form-label fw-bold">Balance Amount</label>
            <input type="text" class="form-control text-end mb-2" formControlName="balanceAmount" readonly>
          </div>
          <div class="col-12">
            <label class="form-label fw-bold">{{'Vendor Balance' | wordReplace }}</label>
            <input type="text" class="form-control text-end mb-2" formControlName="vendorBalance" readonly>
          </div>

          <div class="col-12">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="keyedIn" formControlName="keyedInTransaction"
                (change)="checkkeyedInTransaction()">
              <label class="form-check-label" for="keyedIn">Keyed in transaction</label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12 text-end my-2">
        <button class="btn btn-success me-1" (click)="savePayment()"
          [disabled]="disablePayBtnAfterSubmit || terminalNoSet">
          Save
        </button>
        <button class="btn btn-orange me-1" (click)="cancelPayment()">Cancel</button>
      </div>
    </div>
  </div>
</form>

<div class="modal fade" id="modalPayVendorComments" tabindex="-1" aria-labelledby="modalPayVendorCommentsLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="modalPayVendorCommentsLabel">{{ 'Vendor Comments'| wordReplace}}</h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <textarea class="form-control" style="height: 200px;" [(ngModel)]="vendorComment"></textarea>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btnAS" data-bs-dismiss="modal" (click)="saveVendorComments()">Save</button>
        <button type="button" class="btn btn-orange" data-bs-dismiss="modal">Cancel</button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="modalPayRentalNotes" tabindex="-1" aria-labelledby="modalPayRentalNotesLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="modalPayRentalNotesLabel">Rental Notes</h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <textarea class="form-control" style="height: 200px;" [(ngModel)]="rentalNotes"></textarea>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btnAS" data-bs-dismiss="modal" (click)="saveRentalNotes()">Save</button>
        <button type="button" class="btn btn-orange" data-bs-dismiss="modal">Cancel</button>
      </div>
    </div>
  </div>
</div>

<div *ngIf="processPayment && IsOpenEdgeExpress">
  <app-payment [VendorId]="vendorId" [keyedInTransaction]="keyedInTransaction" [isQDR]="IsQDR"
    [CCAmount]="creditCardAmount" [TransactionType]="transactionType" [voidPayment]="voidPayment"
    (PaymentResponse)="PaymentResponse($event)" [VerifoneId]="verifoneId"
    (ClosePaymentPage)="ClosePaymentPage($event)"></app-payment>
</div>

<div *ngIf="voidPayment && IsOpenEdgeExpress">
  <app-payment [VendorId]="vendorId" [voidPayment]="voidPayment" (PaymentResponse)=voidPaymentResponse()
    [VerifoneId]="verifoneId"></app-payment>
</div>

<div *ngIf="processPayment && IsStrip">
  <app-stripe-payment [VendorId]="vendorId" [keyedInTransaction]="keyedInTransaction" [isQDR]="IsQDR"
    [CCAmount]="creditCardAmount" [TransactionType]="transactionType" [voidPayment]="voidPayment"
    (PaymentResponse)="PaymentResponse($event)" [VerifoneId]="verifoneId"
    (ClosePaymentPage)="ClosePaymentPage($event)"></app-stripe-payment>
</div>

<div *ngIf="voidPayment && IsStrip">
  <app-stripe-payment [VendorId]="vendorId" [voidPayment]="voidPayment" (PaymentResponse)=voidPaymentResponse()
    [VerifoneId]="verifoneId"></app-stripe-payment>
</div>